<div class="fix-action-dialog">
	<h2 mat-dialog-title>Article</h2>
	<mat-dialog-content>
		<mat-card>
			<mat-card-content>

				<form #form="ngForm" fxLayout="column" fxLayoutAlign="space-between" novalidate>
					<div fxLayout="row wrap">

						<mat-form-field class="input-text">
							<mat-label>Category</mat-label>
							<input #category="ngModel" [(ngModel)]="content.category" autocomplete="off" matInput maxlength="16" name="state_select" type="text">
							<mat-hint>16文字まで</mat-hint>
							<mat-error *ngIf="type.errors?.['maxlength'];">長すぎます</mat-error>
						</mat-form-field>

						<mat-form-field class="input-text">
							<mat-label>Status</mat-label>
							<input #status="ngModel" [(ngModel)]="content.status" autocomplete="off" matInput name="status" type="number">
						</mat-form-field>

						<mat-form-field class="input-text">
							<mat-label>Type</mat-label>
							<input #type="ngModel" [(ngModel)]="content.type" autocomplete="off" matInput maxlength="16" name="type" type="text">
							<mat-hint>16文字まで</mat-hint>
							<mat-error *ngIf="type.errors?.['maxlength'];">長すぎます</mat-error>
						</mat-form-field>

						<mat-form-field class="input-text">
							<mat-label>Name</mat-label>
							<input #name="ngModel" [(ngModel)]="content.name" autocomplete="off" matInput maxlength="256" name="name" type="text">
							<mat-hint>256文字まで</mat-hint>
							<mat-error *ngIf="name.errors?.['maxlength'];">長すぎます</mat-error>
						</mat-form-field>

					</div>
					<mat-form-field class="input-text">
						<mat-label>Title...</mat-label>
						<input #title="ngModel" [(ngModel)]="content.value.title" autocomplete="off" matInput maxlength="255" minlength="3" name="title" placeholder="xxxxxx..." required type="text">
						<mat-hint>3文字以上500文字まで</mat-hint>
						<mat-error *ngIf="title.errors?.['required'];">入力してください</mat-error>
						<mat-error *ngIf="title.errors?.['maxlength'];">長すぎます</mat-error>
						<mat-error *ngIf="title.errors?.['minlength'];">短すぎます</mat-error>
					</mat-form-field>
					<mat-form-field class="input-text">
						<textarea #autosize="cdkTextareaAutosize" #description="ngModel" [(ngModel)]="content.value.description" cdkAutosizeMaxRows="5" cdkAutosizeMinRows="1" cdkTextareaAutosize matInput maxlength="1000" name="description" placeholder="Description" type="text"></textarea>
						<mat-hint>1000文字まで</mat-hint>
						<mat-error *ngIf="description.errors?.['maxlength'];">長すぎます</mat-error>
					</mat-form-field>
				</form>

			</mat-card-content>
		</mat-card>
	</mat-dialog-content>

	<div class="spacer"></div>

	<mat-dialog-actions fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-around">
		<mat-slide-toggle [(ngModel)]="content.enabled" [color]="'primary'" name="enable">enable</mat-slide-toggle>
		<button (click)="onAccept()" [disabled]="form.invalid" color="primary" mat-raised-button>OK</button>
		<button (click)="cancel()" color="warn" mat-dialog-close="" mat-raised-button>Cancel</button>
	</mat-dialog-actions>

</div>
